import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';

// Create axios instance with default config
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to include auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Payroll API functions
export const payrollService = {
  // Get all salaries
  getSalaries: async (params = {}) => {
    try {
      const response = await api.get('/payroll/salaries', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching salaries:', error);
      throw error;
    }
  },

  // Get salary by ID
  getSalary: async (id) => {
    try {
      const response = await api.get(`/payroll/salaries/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching salary:', error);
      throw error;
    }
  },

  // Create new salary
  createSalary: async (salaryData) => {
    try {
      const response = await api.post('/payroll/salaries', salaryData);
      return response.data;
    } catch (error) {
      console.error('Error creating salary:', error);
      throw error;
    }
  },

  // Update salary
  updateSalary: async (id, salaryData) => {
    try {
      const response = await api.put(`/payroll/salaries/${id}`, salaryData);
      return response.data;
    } catch (error) {
      console.error('Error updating salary:', error);
      throw error;
    }
  },

  // Get all payrolls
  getPayrolls: async (params = {}) => {
    try {
      const response = await api.get('/payroll/payrolls', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching payrolls:', error);
      throw error;
    }
  },

  // Get payroll by ID
  getPayroll: async (id) => {
    try {
      const response = await api.get(`/payroll/payrolls/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching payroll:', error);
      throw error;
    }
  },

  // Process payroll
  processPayroll: async (payrollData) => {
    try {
      const response = await api.post('/payroll/payrolls/process', payrollData);
      return response.data;
    } catch (error) {
      console.error('Error processing payroll:', error);
      throw error;
    }
  },

  // Approve payroll
  approvePayroll: async (id) => {
    try {
      const response = await api.patch(`/payroll/payrolls/${id}/approve`);
      return response.data;
    } catch (error) {
      console.error('Error approving payroll:', error);
      throw error;
    }
  },

  // Mark payroll as paid
  markPayrollAsPaid: async (id, paymentData) => {
    try {
      const response = await api.patch(`/payroll/payrolls/${id}/mark-paid`, paymentData);
      return response.data;
    } catch (error) {
      console.error('Error marking payroll as paid:', error);
      throw error;
    }
  },

  // Get payroll summary
  getPayrollSummary: async (params = {}) => {
    try {
      const response = await api.get('/payroll/summary', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching payroll summary:', error);
      throw error;
    }
  },

  // Employee: Get own payroll history
  getMyPayrolls: async (params = {}) => {
    try {
      const response = await api.get('/payroll/my-payrolls', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching my payrolls:', error);
      throw error;
    }
  }
};

export default payrollService; 